/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Action_Model_Instruction_HeadingInputs */



/**
* | output |
* | --- |
* | "What the assistant is told" |
*
* @param {Integrations_Action_Model_Instruction_HeadingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const integrations_action_model_instruction_heading = /** @type {((inputs?: Integrations_Action_Model_Instruction_HeadingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Action_Model_Instruction_HeadingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Was der Assistent erfährt")
	return /** @type {LocalizedString} */ ("What the assistant is told")
});